import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturesRoutingModule } from './features-routing.module';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { FeaturesComponent } from './features.component';
import { FeatureGroupsComponent } from './feature-groups/feature-groups.component';
import { FeatureComponent } from './feature/feature.component';
import { FeatureTypesComponent } from './feature-types/feature-types.component';

@NgModule({
  declarations: [FeaturesComponent, FeatureGroupsComponent, FeatureComponent,FeatureTypesComponent],
  imports: [
    CommonModule,
    UbsViewContainersModule,
    FeaturesRoutingModule
  ],
  exports:[]
})
export class FeaturesModule {}
